module.exports = __webpack_public_path__ + "media/images/sp/specials/common/benefit/benefit_wedding_holder-e5bdeb3ba980dd09ab47fc74e9324107.jpg";